export default __webpack_public_path__ + "static/media/4.82b5e10e.md";